import React from 'react'
import { Box } from '@mui/material'
import './BrandButton.scss'

const VidableBrandButton = () => {
    return (
        <Box className="vidable-brand-btn">
            <span>Vidable</span>
        </Box>
    )
}

export default VidableBrandButton